import React from 'react';
import { Text, TextProps } from 'react-native';
import MarkdownConverter from 'turndown-rn';

import { Markdown } from './markdown/markdown';
import { mediaQueryValues } from './media-query';
import { useColors, useFont } from '../hooks/lesson-player.context';
import type { ColorsType } from '../interfaces/colors.type';
import type { FontSizeType } from '../interfaces/fonts.type';

export interface ThemedTextProps extends TextProps {
  children: any;
  type?: keyof ColorsType;
  fontType?: 'primary' | 'secondary';
  fontSize?: FontSizeType;
  isMarkdown?: boolean;
  isHtml?: boolean;
}

export function ThemedText({
  type = 'gray',
  fontType = 'primary',
  fontSize = 'small',
  isMarkdown = false,
  isHtml = false,
  ...props
}: ThemedTextProps) {
  const colors = useColors();
  const color = colors[type];
  const fonts = useFont();
  const mediaQuery = mediaQueryValues();

  const selectedFont =
    fontType === 'primary' ? fonts.primary.regular : fonts.secondary.regular;

  let fontSizeValue = 16;

  switch (fontSize) {
    case 'extraSmall':
      fontSizeValue = mediaQuery.extraSmall;
      break;
    case 'small':
      fontSizeValue = mediaQuery.small;
      break;
    case 'medium':
      fontSizeValue = mediaQuery.medium;
      break;
    case 'large':
      fontSizeValue = mediaQuery.large;
      break;
    case 'extraLarge':
      fontSizeValue = mediaQuery.extraLarge;
      break;
  }
  const lineHeight = fontSizeValue + 2;
  let markdownText = '';
  let convertible = true;

  if (isMarkdown) {
    const markdownConverter = new MarkdownConverter();
    if (isHtml) {
      try {
        markdownText = markdownConverter.turndown(props.children);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        convertible = false;
      }
    } else {
      markdownText = props.children;
    }
  }

  const paddingVertical = 0;

  const component =
    isMarkdown && convertible ? (
      <Markdown
        style={[
          {
            color,
            ...selectedFont,
            fontSize: fontSizeValue,
            lineHeight,
            paddingVertical,
          },
          props.style,
        ]}
      >
        {markdownText}
      </Markdown>
    ) : (
      <Text
        style={[
          {
            color,
            ...selectedFont,
            fontSize: fontSizeValue,
            lineHeight,
          },
          props.style,
        ]}
      >
        {props.children}
      </Text>
    );

  return <>{component}</>;
}
